export const POWERBI_REPORT_PAGE_UPDATE = "POWERBI_REPORT_PAGE_UPDATE";
export const MENU_ITEM_USERS_REPORT_ACCESS = 'MENU_ITEM_USERS_REPORT_ACCESS';

export const setPowerBiReportPage = (data: any) => {
    return (dispatch: any) => {
        dispatch({
            type: POWERBI_REPORT_PAGE_UPDATE,
            payload: data
        })
    }
};